'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SlideContainer = require('./SlideContainer');

var _SlideContainer2 = _interopRequireDefault(_SlideContainer);

var _withCarousel = require('../with-carousel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlideContainer = function SlideContainer(_ref) {
    var children = _ref.children,
        props = (0, _objectWithoutProperties3.default)(_ref, ['children']);
    return _react2.default.createElement(
        _withCarousel.CarouselSubscriber,
        null,
        function (carousel) {
            return _react2.default.createElement(
                _SlideContainer2.default,
                (0, _extends3.default)({}, props, { carousel: carousel }),
                children
            );
        }
    );
};
SlideContainer.propTypes = {
    children: _propTypes2.default.node.isRequired
};

exports.default = SlideContainer;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-carousel/lib/cjs/SlideContainer/index.js
 ** module id = 588
 ** module chunks = 1
 **/